import React from 'react';
import HelpContent from './HelpContent';
import taxi_electrico from 'img/taxiselectricos.png';
//import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const ElectromovilidadTaxisColectivosHelp = () => (
  <HelpContent>
    <h1>Electromovilidad en taxis y taxis colectivos</h1>
    <p>
      Esta medida se sostiene en el recambio tecnológico de taxis y colectivos propulsados por combustibles fósiles, a tecnología basada en la energía eléctrica.
       Esta medida considera una penetración del 100% de taxis eléctricos (colectivos y taxis básicos) al 2040 a nivel nacional.
    </p>
    <img src={taxi_electrico} alt="Taxi Eléctrico" />
    <label>Figura: Taxi Eléctrico</label>
    <p>
    <strong>Trayectoria 1:</strong>  en 2030 el 25% del parque de taxis y colectivos es eléctrico, en 2035 el 67% y en 2040 el 100% de vehiculos del parque es eléctrico.
    </p>
  </HelpContent>
);

export default ElectromovilidadTaxisColectivosHelp;
